import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const ErrorPopover = ({text}) => {
    return (
        <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={makePopover(text)}>
            <span className='glyphicon glyphicon-exclamation-sign text-danger'/>
        </OverlayTrigger>);
};

const makePopover = text => {
    return (
        <Popover id="popover-trigger-hover-focus" title="Error">
            {text}
        </Popover>
    );
};

ErrorPopover.propTypes = {
    text: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/table/ErrorPopover.js